module.exports = __webpack_public_path__ + "static/media/stfrancisxavier.d685b1cf.webp";